// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"29":"0b5fb0ae78d8638b","87":"e4ef2bc8e70bef7d","311":"4b244027c05e6292","453":"cfc8a89debae3465","609":"cb8dba965500a230","686":"5fd61ee027f0974e","852":"7cbc26af23d4998d"}[chunkId] + ".js";
};